import React from "react";
import { getCumulativeSum } from "../../../../helpers/accounting-helper";
import { ACCOUNT_SUMMARY, GROUP_BY_TYPES, GROUP_METHODS } from "../../../../data/constants";
import moment from "moment";
import { Typography } from "@mui/material";
import ZeroScreen from "../zero-screen";
import { isMobileTabDevice } from "../../../../helpers/device-info-helper";
import SortFilter from "../sort-filter";

export function getGroupedData(oldArr: any, groupId: any) {
  const result: any = {};
  oldArr?.forEach((item: any) => {
    const id = item?.[groupId];
    if (!result[id]) {
      result[id] = [];
    }
    result[id] = [...result[id], item];
  });
  return result;
}

export function renderBillDetails(
  billsDetails: any,
  setInvoiceSummary: any,
  fetchInvoiceDetails: any
) {
  return !!billsDetails?.length
    ? billsDetails.map((billsDetail: any, i: number) => {
        return (
          <div
            key={i}
            onClick={() => {
              setInvoiceSummary(true);
              fetchInvoiceDetails(billsDetail.saleId);
            }}
          >
            <div
              className={
                "flex sm:flex-col justify-between items-center text-14 border-b border-[#EBEBEB] p-16 smd:p-12 cursor-pointer"
              }
            >
              <div className="flex justify-between  basis-3/4 smd:basis-2/3  sm:w-full">
              <div className="pl-5 flex flex-col  mr-10">
                <div className="bg-[#0000000D] font-semibold py-4 px-8 rounded-[6px] mb-8">
                  #{billsDetail?.billNumber}
                </div>
                <div className="opacity-50 text-[12px] sm:mb-8">
                  {moment(billsDetail.time).format("hh:mm a")}
                </div>
              </div>
              <div className="flex smd:flex-col !items-center smd:items-end justify-between smd:!justify-center basis-2/3">
              <div className="px-20 sm:px-0 flex smd:text-[13px]">
                <div className="opacity-50 mr-2">Bill Total: </div>
                <div className=""> ₹{Number(billsDetail.amount).toFixed(2)}</div>
              </div>
              <div className="px-20 sm:px-0 flex smd:text-[13px]">
                <div className="opacity-50 mr-2">Collected: </div>
                <div className=""> ₹{Number(billsDetail.amount).toFixed(2)}</div>
              </div>
              </div>
              </div>
              <div className="flex flex-col sm:flex-row sm:w-full sm:justify-center bg-[#E8F0FF] rounded-[8px] text-[12px] p-8">
                <div className="text-[#3A5E8B] sm:pr-4">Paid By Mode</div>
                <div className="text-[#3A5E8B] text-center font-semibold">
                  ₹{Number(billsDetail.amount).toFixed(2)}
                </div>
              </div>
            </div>
          </div>
        );
      })
    : <ZeroScreen showSummaryDetails={billsDetails.length !== 0} summaryType={ACCOUNT_SUMMARY.payment.id}/>;
}

//function to all the cases of group by user and payment before and after sorting
function getHeaderText(headerData: any) {
  const isPaymentGroupMethod = headerData?.groupMethod === GROUP_METHODS?.Payment;
  const isBranchGrouping = headerData?.groupBy === GROUP_BY_TYPES?.branch;

  const fallbackBranchName =
    headerData?.branchesData[headerData?.options[0]?.branchId]?.branchName;

  if (isPaymentGroupMethod) {
    return isBranchGrouping
      ? headerData?.headerName || fallbackBranchName
      : headerData?.options[0]?.bizBrandName;
  } else {
    return headerData?.headerName || fallbackBranchName;
  }
}

export function renderRightBillSection(
  setSelectedMode: any,
  selectedMode: any,
  hideFilterMobile: any,
  billsDetails: any,
  setSearchIcon: any,
  setBillsDetailsMap: any,
  dropdownItemsBill: any
): JSX.Element {
  return (
    <>
      <div className="flex smd:flex-col items-start ">
        <div className="flex">
          {isMobileTabDevice() && (
            <div
              className="rista-sprite ic-back-icon  smd:items-center smd:justify-center cursor-pointer"
              onClick={() => {
                setSelectedMode({});
                hideFilterMobile({});
              }}
            ></div>
          )}
          <div className="flex text-20 smd:text-[18px] font-inter font-semibold line-clamp-1">
            {selectedMode?.mode}
          </div>
        </div>
        {renderBillDetailsHeader(billsDetails)}
      </div>
      <div className="flex">
        <div
          className={`w-[38px] mr-12 text-[13px] h-[38px] px-8 py-10 border border-[#3a5e8b1a] hover:!shadow-[0px_3px_6px_#00000029] hover:border-black cursor-pointer rounded-[6px] flex gap-1.25 justify-center items-center overflow-hidden`}
          onClick={() => setSearchIcon(true)}
        >
          <span className="w-[18px] rista-sprite ic-search-icon ml-[1%]"></span>
        </div>
        <SortFilter
          dataToSort={billsDetails}
          handleSort={setBillsDetailsMap}
          sortOptionsMap={dropdownItemsBill}
        />
      </div>
    </>
  );
}

export function renderBillDetailsHeader(billsDetails: any): JSX.Element {
  return (
    <div className="flex items-center justify-center">
      <p className="!ml-5 text-[#0000007A] border-r-2 pr-3 mt-6">
        <span>{billsDetails?.length}</span>
        <span className="ml-2">Payments</span>
      </p>
      <p className="text-[#0000007A] px-3 pt-6">
        <span>
          ₹{Number(getCumulativeSum(billsDetails, "amount")).toFixed(2)}
        </span>
      </p>
    </div>
  );
}

export function renderPaymentModeHeader(option: any): JSX.Element {
  return (
    <div className={`flex justify-between w-[100%]`}>
      <div className="flex flex-col justify-between font-normal">
        <p className="text-15">{option?.mode}</p>
        <p className="text-13 opacity-50">{option?.count} Payments</p>
      </div>
      <div className="text-[14px] text-[#3A5E8B] smd:pr-[12px] flex items-center">
        <span>Payment Recieved:</span>
        <span className="ml-5 font-semibold">
          ₹{Number(option?.amount).toFixed(2)}
        </span>
      </div>
    </div>
  );
}

export function renderNoResultSearch(): JSX.Element {
  return (
    <div className="flex flex-col justify-center items-center w-full mt-56">
      <div className="flex items-center justify-center w-[72px] h-[72px] bg-opacity-5 bg-[#000] rounded-[8px]">
        <div className="rista-sprite ic-not-found"></div>
      </div>
      <p className="text-20 font-semibold mt-24 mb-6 opacity-40">
        No results found
      </p>
      <p className="text-13 font-normal mb-6 opacity-40 mt-[0px]">
        Please try using other name or keyword
      </p>
    </div>
  );
}

export function renderPaymentByUserHeader(option: any): JSX.Element {
  return (
    <div className={`flex justify-between !w-[100%]`}>
      <div className="flex flex-col justify-between font-normal">
        <p className="text-15">{option?.userName?.firstName}</p>
        <p className="text-13 opacity-50">{option?.count} Payments</p>
      </div>
      <div className="text-[14px] text-[#3A5E8B] smd:pr-[12px] flex items-center">
        <span>Payment Recieved:</span>
        <span className="ml-5 font-semibold">
          ₹{Number(option?.amount).toFixed(2)}
        </span>
      </div>
    </div>
  );
}

export function renderAccordionHeader(headerData: any): JSX.Element {
  return headerData ? (
    <div className="w-full flex smd:!pr-0">
      <Typography
        component={"span"}
        className="flex items-center !m-0 justify-between w-full"
      >
        <div className="flex flex-col">
          <div className="flex items-center">
            <span
              className={`text-[15px] capitalize ${
                headerData.isSelected ? "font-semibold" : "font-medium"
              }`}
            >
              {getHeaderText(headerData)}
            </span>
          </div>
          <div className="flex items-center">
            <span
              className={`text-[13px] capitalize font-medium text-[#0000007A]`}
            >
              {getCumulativeSum(headerData?.options, "count")}
            </span>
            <span
              className={`ml-5 text-[13px] capitalize font-medium text-[#0000007A]`}
            >
              {"payments"}
            </span>
          </div>
        </div>
        <div className="text-[14px] text-[#3A5E8B] smd:pr-[12px]">
          <span>Payment Recieved:</span>
          <span className="ml-5 font-semibold">
            ₹{Number(getCumulativeSum(headerData?.options, "amount")).toFixed(2)
              }
          </span>
        </div>
      </Typography>
    </div>
  ) : (
    <></>
  );
}

export function getTotalPaymentOrder(paymentData: any): JSX.Element {
  return (
    <div className="flex border-b-[1px] bg-white py-15">
      <div className="bg-white pl-20 pr-15 border-r-[1px] basis-1/2">
        <span className="text-[#0000007A] text-[14px] font-normal">Payment Received</span>
        <br />
        <span className="text-black text-[17px] font-semibold">
          ₹{Number(getCumulativeSum(Object.values(paymentData), "amount")).toFixed(2)}
        </span>
      </div>
      <div className="bg-white pl-20 pr-15 basis-1/2">
        <span className="text-[#0000007A] text-[14px] font-normal">Orders</span>
        <br />
        <span className="text-black text-[17px] font-semibold">
          {getCumulativeSum(Object.values(paymentData), "count")}
        </span>
      </div>
    </div>
  );
}
